import React, { useState, useEffect } from 'react'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import { InputNumber } from 'baseComponent/numericInput'
import DropDownClearIcon from 'meinian-package/src/baseComponent/dropDownClearIcon'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({
  minVolume,
  maxVolume,
  allText = '不限',
  ranges = [
    [0, 50],
    [50, 100],
    [100, 200],
    [200, 300],
    [300, 400],
    [400, 500],
    [500, 600],
    [600, 700],
    [700, 800],
    [900, 1000],
    [1000, 1500],
    [1500, ''],
  ],
  changeVolume,
  defaultText = '不限',
  itemStyle,
  trigger = 'hover',
  wrapperStyle,
  onBlur,
  onVisibleChange,
}) => {
  const [type, setType] = useState(0)
  const [displayText, setDisplayText] = useState(defaultText)
  const [isOpenSaleSort, setSsOpenSaleSort] = useState(false)

  useEffect(() => {
    if (!minVolume && !maxVolume) {
      setDisplayText(defaultText)
      return
    }
    setDisplayText((minVolume === 10000 || !maxVolume)
      ? `${minVolume}以上`
      : `${!minVolume ? 0 : minVolume || ''}-${maxVolume || ''}`)
  }, [minVolume, maxVolume])

  const handleSaleSort = (_type, _minVolume, _maxVolume) => {
    changeVolume && changeVolume(_minVolume, _maxVolume)
    if (_type === 1) {
      if (!_minVolume && !_maxVolume) {
        setDisplayText(defaultText)
        setType(_type)
      } else {
        setDisplayText(!_maxVolume ? `${_minVolume}以上` : `${_minVolume || '0'}-${_maxVolume}`)
        setType(_type)
      }
      setSsOpenSaleSort(false)
    }
  }

  const isVisibleJudge = (_isOpenSaleSort) => {
    setSsOpenSaleSort(_isOpenSaleSort)
    onVisibleChange(_isOpenSaleSort)
  }
  const menu3 = (
    <div className={styles.priceZoneContent} onClick={(e) => e.stopPropagation()}>
      <div className="priceZoneContentRange">
        <InputNumber
          style={{ color: type === 2 ? 'var(--m-link-normal)' : 'inherit' }}
          className="meinian-numeric-input"
          maxLength="6"
          noTip
          onClick={e => e.stopPropagation()}
          onChange={(value) => {
            handleSaleSort(2, value, maxVolume)
          }}
          onBlur={onBlur}
          value={minVolume}
          placeholder="最低价"
        />
        &nbsp;-&nbsp;
        <InputNumber
          style={{ color: type === 2 ? 'var(--m-link-normal)' : 'inherit' }}
          className="meinian-numeric-input"
          maxLength="6"
          noTip
          onClick={e => e.stopPropagation()}
          onChange={(value) => { handleSaleSort(2, minVolume, value) }}
          value={maxVolume}
          onBlur={onBlur}
          placeholder="最高价"
        />
      </div>
      <div className="priceZoneContentRangeList">
        <div className="priceZoneContentRangeListItem" onClick={() => handleSaleSort(1, '', '')}>
          {allText}
        </div>
        {ranges.map(range => <div className="priceZoneContentRangeListItem" onClick={() => handleSaleSort(1, range[0], range[1])}>
          {!range[1] ? `${range[0]}以上` : `${range[0] || '0'}~${range[1]}`}
        </div>)}
      </div>
    </div>
  )

  return (
    <div className={styles['meinian-sales-volume-drop']} style={{ display: 'inline-block', ...wrapperStyle }}>
      <Dropdown
        overlay={menu3}
        trigger={trigger}
        overlayClassName=""
        open={isOpenSaleSort}
        onOpenChange={isVisibleJudge}
      >
        <span style={itemStyle} className={classNames(`${minVolume || maxVolume || displayText === allText ? 'meinian-sort-item-active' : 'meinian-sort-item'} dropDownClearIcon`, { clear: minVolume || maxVolume })}>
          <DropDownClearIcon
            visible={isOpenSaleSort}
            onClear={() => {
              handleSaleSort(1, '', '')
            }}
          >
            {displayText}
          </DropDownClearIcon>
        </span>
      </Dropdown>
    </div>
  )
}
